import $ from "jquery";
import "swipebox/lib/jquery-2.1.0.min.js";

import "simplelightbox/dist/simple-lightbox.jquery";

export function Swipebox() {
  const $selector = $(".js-swipebox a");

  var lightbox1 = $(".js-swipebox a").simpleLightbox();

  // $selector.attr("data-lightbox", "gallery");

  // $selector.swipebox({
  //   afterOpen: e => {
  //     if ($selector.length == 1) {
  //       $("#swipebox-bottom-bar").addClass("is-hidden");
  //     }
  //   }
  // });
  // $(document.body).on("click", e => {
  //   if (
  //     e.target.classList.contains("slide") &&
  //     e.target.classList.contains("current")
  //   ) {
  //     $("#swipebox-close").trigger("click");
  //   }
  // });
}

Swipebox();
